import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterPathMixin from '@/helpers/mixins/RouterPathMixin';
import me from '@/plugins/graphql/queries/me.gql';
let BaseTopNavAppName = class BaseTopNavAppName extends Mixins(ViewportSizeMixin, RouterPathMixin) {
    get linkName() {
        return "My In-App Store";
    }
    get userFullName() {
        return `${this.me.firstName} ${this.me.lastName}`;
    }
};
__decorate([
    Prop({ type: String, required: true })
], BaseTopNavAppName.prototype, "appUuid", void 0);
BaseTopNavAppName = __decorate([
    Component({
        apollo: {
            me: {
                query: me,
                skip() {
                    return !this.$store.state.session.token;
                },
            },
        },
        components: { AppBasicDetails },
    })
], BaseTopNavAppName);
export default BaseTopNavAppName;
